import { ActionTypes } from '../actions';

export const INITIAL_STATE = {
  users: {},
  selectedEmail: null,
  filter: {},
  feedLoading: false,
};

const FeedReducer = (state = INITIAL_STATE, action) => { // changes state value by 1
  switch (action.type) {
    case ActionTypes.UPDATE_FEED:
      return {
        ...state,
        ...action.payload,
      };
    case ActionTypes.UPDATE_FEED_PROFILE_PHOTO:
      return {
        ...state,
        users: {
          ...state.users,
          [action.payload.email]: {
            ...state.users[action.payload.email],
            answers: {
              ...state.users[action.payload.email]?.answers,
              profile_photo: {
                ...state.users[action.payload.email]?.answers?.profile_photo,
                answer: action.payload.url,
              },
            },
          },
        },
      };
    case ActionTypes.CLEAR_FEED:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default FeedReducer;
